import api from '../services/Api';
import { fetchingActiveOrComingSoonAction, fetchedActiveOrComingSoonAction, fetchingClosedAction, fetchedClosedAction } from '../actions/HomepageActions';
import { networkErrorAction } from '../actions/UiActions';
import { HOMEPAGE_ACTIVE_PAGE_SIZE, HOMEPAGE_CLOSED_PAGE_SIZE } from '../parameters';

class RaffleRepository {

	/**
	 * @return {function(*=): (PromiseLike<T> | Promise<T> | *)}
	 */
	fetchActiveOrComingSoon = (page) => (dispatch) => {
		dispatch(fetchingActiveOrComingSoonAction());
		return api.get('/raffles/active-or-coming-soon', {
			params: {
				page,
				pageSize: HOMEPAGE_ACTIVE_PAGE_SIZE
			}
		}).then(res => {
			const { documents, total } = res.data;
			dispatch(fetchedActiveOrComingSoonAction(documents, total, page));
		}).catch((error) => {
			dispatch(networkErrorAction(error));
		});
	};

	/**
	 * @return {function(*=): (PromiseLike<T> | Promise<T> | *)}
	 */
	fetchClosed = (page) => (dispatch) => {
		dispatch(fetchingClosedAction());
		return api.get('/raffles/closed', {
			params: {
				page,
				pageSize: HOMEPAGE_CLOSED_PAGE_SIZE
			}
		}).then(res => {
			const { documents, total } = res.data;
			dispatch(fetchedClosedAction(documents, total, page));
		}).catch((error) => {
			dispatch(networkErrorAction(error));
		});
	};

	/**
	 * @return {function(*=): (PromiseLike<T> | Promise<T> | *)}
	 */
	fetchRaffle = (id, fetchingAction, fetchedAction) => (dispatch) => {
		dispatch(fetchingAction());
		return api.get('/raffles/' + id).then(res => {
			const raffle = res.data;
			dispatch(fetchedAction(raffle));
		}).catch((error) => {
			const response = error.response;
			if (response.status === 404 || response.status === 422) {
				dispatch(fetchedAction(null));
			}
			else {
				dispatch(networkErrorAction(error));
			}
		});
	};

}

export default new RaffleRepository();



// WEBPACK FOOTER //
// ./repositories/RaffleRepository.js